export default __webpack_public_path__ + "ff583b3c72183489f81a61588bf03973.jpg";